import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/Digitize.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Renowned San Francisco Software Company for Modern Businesses
            </h2>
            <p>
              In the tech hub of San Francisco, where innovation is the
              currency, business digitization is no longer a choice but a
              necessity. It's the strategic software solutions that drive this
              transformation, providing the means to unlock new levels of
              efficiency and competitiveness.
            </p>
            <p>
              TekRevol is a modern-day San Francisco software company assisting
              businesses to hire the right talent or expand their in-house team
              capacity and build industry-leading products.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
